<app-template-progress [control]="control" [start]="start" [end]="end" [type]="type" [unit]="unit" [prefix]="prefix" />
